import { hero } from './content'

// the visitor's region as the API prices them: GB for the UK, US for everyone else (and until pricing loads)
export const videoRegion = (currency) => (currency === 'GBP' ? 'GB' : 'US')

/**
 * Martin's hero video for this visitor: the UK or US cut, portrait on a phone, with its frame ratio and poster.
 *
 * @param currency  the visitor's pricing currency, 'GBP' or 'USD'; empty until it loads
 * @param portrait  true on a phone, where the 9:16 cut plays
 */
export const heroVideo = (currency, portrait) => {
  const { video } = hero.value
  const orientation = portrait ? 'portrait' : 'landscape'
  return {
    title: video.title,
    wid: video.wids[videoRegion(currency)][orientation],
    ...video[orientation],
  }
}
